import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { SocialIcons } from "./SocialIcons";

const LINKS = [
  { to: "/", label: "Home", id: "home" },
  { to: "/music", label: "Music", id: "music" },
  { to: "/news", label: "News", id: "news" },
  { to: "/bespoke", label: "Bespoke Music", id: "bespoke" },
  { to: "/about", label: "About Me", id: "about" },
  { to: "/press", label: "Press", id: "press" },
  { to: "/contact", label: "Contact", id: "contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 inset-x-0 z-40 bg-navy-950/75 backdrop-blur-xl border-b border-white/5">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-24 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-link" aria-label="Open Horizon Records home">
          <Logo size={68} />
        </Link>
        <nav className="hidden lg:flex items-center gap-7" data-testid="main-nav">
          {LINKS.map((l) => (
            <NavLink
              key={l.id}
              to={l.to}
              data-testid={`nav-${l.id}-link`}
              className={({ isActive }) =>
                `text-[13px] tracking-[0.15em] uppercase transition-colors duration-300 ${
                  isActive ? "text-gold-300" : "text-slate-300 hover:text-gold-200"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden xl:block">
          <SocialIcons size={16} />
        </div>
        <button
          className="lg:hidden text-gold-300 p-2"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <nav
          className="lg:hidden glass-panel border-t border-gold-400/10 px-6 py-5 flex flex-col gap-4"
          data-testid="mobile-nav"
        >
          {LINKS.map((l) => (
            <NavLink
              key={l.id}
              to={l.to}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${l.id}-link`}
              className={({ isActive }) =>
                `text-sm tracking-[0.15em] uppercase ${isActive ? "text-gold-300" : "text-slate-300"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <SocialIcons size={18} className="pt-2" />
        </nav>
      )}
    </header>
  );
};
